import DateFnsUtils from '@date-io/date-fns'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { Grid, ListItem, ListItemText, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'

export const DecreaseOriginalValueForm = (props: any) => {
  let history = useHistory()
  let location = useLocation()
  const editData: any = location?.state
  const { formMode } = props
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [record, setRecord] = useState(false)
  const [, setIsFormDirty] = useState(true)

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }
  const { menu } = useMenuOption()

  /* -------------------------------------------- */
  /*                   USE FORM                   */
  /* -------------------------------------------- */
  const { register, setValue, control } = useForm<any>({
    defaultValues: {},
    mode: 'onSubmit',
  })

  /* -------------------------------------------- */
  /*                    QUEARY                    */
  /* -------------------------------------------- */

  let dummyData = [
    {
      AssetsNo: 'AS1',
      AssetName: 'Asset Name 1',
      StartDate: '2021-05-27T12:44:01.162Z',
      Source: 'Direct Purchase',
      OriginalAmount: 3000,
      Quantity: 1,
      ModelNo: 'M101',
      UOMName: 'Unit',
      ResidualValue: 2,
      ResidualPercentage: 10,
    },
    {
      AssetsNo: 'AS2',
      AssetName: 'Asset Name 2',
      StartDate: '2021-05-27T12:44:01.162Z',
      Source: 'Direct Purchase',
      OriginalAmount: 4000,
      Quantity: 5,
      ModelNo: 'M102',
      UOM: 'Unit',
      ResidualValue: 5,
      ResidualPercentage: 15,
    },
    {
      AssetsNo: 'AS3',
      AssetName: 'Asset Name 3',
      StartDate: '2021-05-27T12:44:01.162Z',
      Source: 'Direct Purchase',
      OriginalAmount: 3000,
      Quantity: 8,
      ModelNo: 'M103',
      UOM: 'Unit',
      ResidualValue: 23,
      ResidualPercentage: 40,
    },
    {
      AssetsNo: 'AS4',
      AssetName: 'Asset Name 4',
      StartDate: '2021-05-27T12:44:01.162Z',
      Source: 'Direct Purchase',
      OriginalAmount: 3000,
      Quantity: 1,
      ModelNo: 'M104',
      UOM: 'Unit',
      ResidualValue: 2,
      ResidualPercentage: 10,
    },
  ]

  return (
    <>
      <MainHeader
        mainBtn="close"
        onClick={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/Decrease-original-value`
          )
        }}
        smTitle={'Fixed Assets'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Decrease in Original Value', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents>
          <Controller
            render={({ value, onChange }) => {
              const defVal = dummyData?.filter(
                coa => coa?.AssetsNo === editData?.AssetNo
              )[0]
              return (
                <Autocomplete
                  options={
                    dummyData?.sort((a, b) => {
                      return a?.AssetsNo?.localeCompare(b?.AssetsNo)
                    }) || []
                  }
                  getOptionLabel={option => `${option?.AssetsNo}`}
                  fullWidth
                  onChange={(event, value: any) => {
                    if (value) {
                      setValue('AssetName', value?.AssetName)
                      setValue('StartDate', new Date(value?.StartDate))
                      setValue('Source', value?.Source)
                      setValue('OriginalAmount', value?.OriginalAmount)
                      setValue('Quantity', value?.Quantity)
                      setValue('ModelNo', value?.ModelNo)
                      setValue('UOMName', value?.UOMName)
                      setValue('ResidualValue', value?.ResidualValue)
                      setValue('ResidualPercentage', value?.ResidualPercentage)
                    }
                  }}
                  defaultValue={defVal}
                  disabled={mode === 'approve-reject'}
                  renderOption={(props, option) => {
                    return (
                      <div>
                        <div>
                          <span className="xsTitle">{props?.AssetsNo}</span>
                        </div>
                      </div>
                    )
                  }}
                  renderInput={(params: any) => {
                    return (
                      <div>
                        <TextField
                          {...params}
                          label="Assets No."
                          style={{ width: '100%' }}
                          required
                          margin="normal"
                        />
                      </div>
                    )
                  }}
                />
              )
            }}
            label="Assets No."
            name="AssetsNo"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            margin="normal"
            ref={register}
            required
            defaultValue={editData?.AssetNo}
          />
          <Controller
            as={TextField}
            id="standard-basic"
            name="AssetName"
            label="Asset Name"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.AssetName ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="StartDate"
              label="Start Date"
              control={control}
              format="dd/MM/yyyy"
              readOnly
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                style: { display: 'none' },
              }}
              className="left"
              value={new Date()}
              defaultValue={menu?.obj?.StartDate ?? null}
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="Source"
            label="Source"
            autoComplete="off"
            control={control}
            className="right"
            margin="dense"
            ref={register}
            defaultValue={menu?.obj?.Source ?? 'N/A'}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="OriginalAmount"
            label="Original Amount"
            className="left"
            defaultValue={menu?.obj?.OriginalAmount ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="Quantity"
            label="Quantity"
            className="right"
            defaultValue={menu?.obj?.Quantity ?? 0}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
          <Grid spacing={1} container className="table-content">
            <Grid item xs={6} style={{ placeSelf: 'start' }}>
              <Controller
                as={TextField}
                id="standard-basic"
                name="ModelNo"
                label="Model No."
                autoComplete="off"
                control={control}
                margin="dense"
                ref={register}
                className="left"
                defaultValue={menu?.obj?.ModelNo ?? 'N/A'}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={6} style={{ placeSelf: 'start' }}>
              {
                <Controller
                  as={TextField}
                  id="standard-basic"
                  name="UOM"
                  label="UOM"
                  autoComplete="off"
                  control={control}
                  className="right"
                  margin="dense"
                  ref={register}
                  defaultValue={menu?.obj?.UOMName ?? 'N/A'}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: true,
                  }}
                />
              }
            </Grid>
          </Grid>

          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualValue"
            label="Residual Value"
            className="left"
            defaultValue={menu?.obj?.ResidualValue ?? 0}
            decimalScale={2}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
          <Controller
            as={<NumberFormat allowNegative={false} />}
            thousandSeparator
            customInput={TextField}
            ref={register}
            control={control}
            margin="dense"
            name="ResidualPercentage"
            label="Residual (%)"
            className="right"
            defaultValue={menu?.obj?.Residual ?? 0}
            decimalScale={4}
            fixedDecimalScale
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
          />
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Decrease In Original Value',
            },
          }}
        >
          <>
            <Controller
              as={KeyboardDatePicker}
              name="ChangeDate"
              label="Change Date"
              control={control}
              format="dd/MM/yyyy"
              fullWidth
              margin="dense"
              allowKeyboardControl
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                style: { display: 'none' },
              }}
              value={new Date()}
              defaultValue={editData ? editData?.ChangeDate : new Date()}
            />
            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="DecreasedAmount"
              label="Decreased Amount"
              className="left"
              defaultValue={menu?.obj?.DecreaseAmount ?? 0}
              decimalScale={2}
              fixedDecimalScale
            />
            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangedOriginalAmount"
              label="Changed Original Amount"
              className="right"
              defaultValue={menu?.obj?.ChangeOriginalAmount ?? 0}
              decimalScale={2}
              fixedDecimalScale
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />
            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangeUnitPrice"
              label="Change Unit Price"
              className="left"
              defaultValue={menu?.obj?.ChangeUnitPrice ?? 0}
              decimalScale={2}
              fixedDecimalScale
            />
            <Controller
              as={<NumberFormat allowNegative={false} />}
              thousandSeparator
              customInput={TextField}
              ref={register}
              control={control}
              margin="dense"
              name="ChangedResidualValue"
              label="Changed Residual Value"
              className="right"
              defaultValue={menu?.obj?.ChangedResidualValue ?? 0}
              decimalScale={2}
              fixedDecimalScale
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
            />

            <VoiceTextField
              mounted={true}
              label="Document Description"
              name="Description"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />
            <VoiceTextField
              mounted={true}
              label="Reason"
              name="Reason"
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              setIsFormDirty={setIsFormDirty}
              control={control}
              controllerProps={{
                ref: register,
                autoComplete: 'off',
              }}
              required
            />
          </>
        </CardContents>
      </ContentWrapper>

      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(
            `/fixed-assets/${CompanyID}/assets-change/decrease-original-value`
          )
        }}
      />
    </>
  )
}
